import React, { useEffect, useState } from 'react';
import {
    API_ADD_CENTER,
    API_BRANCHES,
    API_UPDATE_CENTER,
} from '../Config/ApiUrlConstant';
import { useAuth } from '../AuthContext';
import { apiJson } from '../utils/apiClient';
import { confirmAction } from '../utils/confirmAction';

const AddEditCenter = ({ showAddEdit, setShowAddEdit, actionType, centerToEdit, refreshCenters }) => {
    const [formData, setFormData] = useState({
        branch_id: '',
        center_name: '',
    });
    const [branches, setBranches] = useState([]);
    const { logout } = useAuth();

    useEffect(() => {
        if (actionType === 'edit' && centerToEdit) {
            setFormData({
                branch_id: centerToEdit.branch_id || '',
                center_name: centerToEdit.center_name || '',
            });
            return;
        }

        if (actionType === 'add') {
            setFormData({
                branch_id: '',
                center_name: '',
            });
        }
    }, [actionType, centerToEdit]);

    useEffect(() => {
        if (!showAddEdit) {
            return;
        }

        const loadBranches = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(API_BRANCHES, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({}),
                });

                if (response.status === 401 || response.status === 403) {
                    logout();
                    return;
                }

                const responseData = await response.json();
                setBranches(responseData.data || []);
            } catch (error) {
                setBranches([]);
            }
        };

        void loadBranches();
    }, [logout, showAddEdit]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const url = centerToEdit ? API_UPDATE_CENTER : API_ADD_CENTER;
        const payload = centerToEdit?.id ? { ...formData, id: centerToEdit.id } : formData;
        if (!confirmAction(centerToEdit ? 'update this center' : 'add this center')) return;

        try {
            const { data: responseData } = await apiJson(url, {
                method: 'POST',
                body: JSON.stringify(payload),
            });
            if (responseData.status) {
                alert(responseData.message);
                refreshCenters();
                setShowAddEdit(false);
                setFormData({
                    branch_id: '',
                    center_name: '',
                });
            } else {
                alert(responseData.message);
            }
        } catch (error) {
        }
    };

    return (
        <div className={`modal ${showAddEdit ? 'd-block' : 'd-none'}`} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title ft-left" style={{ width: '100%' }}>
                            {centerToEdit ? 'Edit Center' : 'Add New Center'}
                        </h5>
                        <button type="button" className="close ft-right" style={{ width: '10%' }} onClick={() => setShowAddEdit(false)}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Branch No</label>
                                <select
                                    className="form-control"
                                    name="branch_id"
                                    value={formData.branch_id}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="">Select Branch</option>
                                    {branches.map((branch) => (
                                        <option key={branch.id} value={branch.id}>
                                            {branch.branch_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Center Name</label>
                                <input
                                    type="text"
                                    name="center_name"
                                    className="form-control"
                                    value={formData.center_name}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowAddEdit(false)}>
                                    Close
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    {centerToEdit ? 'Update' : 'Add'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddEditCenter;
